// extracted by mini-css-extract-plugin
module.exports = {"root":"Deal_root__mANlX","square":"Deal_square__va3x4"};